<script>
    /**
     * Indicator text.
     * @type {string | null }
     */
    export let text = "Scroll to Continue";

    /**
     * Amount of time in milliseconds to wait before showing scroll indicator.
     * @type { number }
     */
    export let timeToShow = 1500;

    let showScrollIndicator = false;

    function updateScroll() {
        if (window.scrollY > 0) {
            showScrollIndicator = false;
            clearTimeout(scrollTimeout);
        } else {
            showScrollIndicator = true;
        }
    }

    let scrollTimeout = setTimeout(() => {
        showScrollIndicator = true;
    }, timeToShow);
</script>

<svelte:window on:scroll={updateScroll} />

<div class="scroll-prompt" class:scroll-prompt--hide={!showScrollIndicator}>
    <span class="scroll-prompt__text">{text}</span>
    <div class="scroll-prompt__icon">
        <svg
            height="16"
            viewBox="0 0 16 16"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
            ><path
                clip-rule="evenodd"
                d="m9.5858 8.00008-5.29289-5.2929 1.41421-1.41421 6.70708 6.70711-6.70708 6.70712-1.41421-1.4142z"
                fill="currentColor"
                fill-rule="evenodd"
            /></svg
        >
    </div>
</div>

<style>
    .scroll-prompt {
        color: var(--color-text-body);

        display: flex;
        flex-direction: column;
        align-items: center;
        position: fixed;
        bottom: 1rem;
        left: 50vw;
        transform: translateX(-50%);
        z-index: 1;
        opacity: 1;
        transition: opacity 0.5s ease-in;
        animation: scroll-prompt-bobbing 5s infinite;
    }

    @keyframes scroll-prompt-bobbing {
        0% {
            transform: translateY(0%) translateX(-50%);
        }
        50% {
            transform: translateY(-25%) translateX(-50%);
        }
        100% {
            transform: translateY(0%) translateX(-50%);
        }
    }

    .scroll-prompt--hide {
        opacity: 0;
        pointer-events: none;
    }

    .scroll-prompt__text {
        font-family: var(--fonts-sans);
        font-size: var(--scale-1);
        font-weight: 700;
        text-shadow: 0 0 5px #000;
    }

    @media only screen and (min-width: 60em) {
        .scroll-prompt__text {
            font-size: var(--scale-2);
        }
    }

    .scroll-prompt__icon {
        height: 1rem;
        width: 1rem;
        transform: rotate(90deg);
    }
</style>
